import script from "./crossSaleContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./crossSaleContainer.vue?vue&type=script&setup=true&lang=ts"

import "./crossSaleContainer.vue?vue&type=style&index=0&id=1cc7d745&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cc7d745"]])

export default __exports__